/**
 * Regra de largura das colunas do quadro.
 *
 * As colunas sao fluidas: dividem a largura que o quadro recebeu, e por isso o zoom do
 * navegador e o menu lateral aberto ou recolhido nao pedem tratamento proprio, porque
 * tudo isso chega aqui como largura disponivel. Abaixo do minimo legivel nao ha como
 * dividir, e o quadro passa a rolar com colunas confortaveis: se a pessoa vai rolar de
 * qualquer jeito, nao ha motivo para ela ler coluna espremida.
 *
 * A regra fica em funcao pura porque o ambiente de teste nao calcula layout.
 */

/** Menor coluna em que o cartao ainda se le, na forma compacta. */
export const COLUNA_MINIMA = 132;

/** Coluna do quadro que precisa rolar. */
export const COLUNA_CONFORTAVEL = 200;

/** Abaixo desta largura o quadro mostra uma coluna por vez, com a seguinte aparecendo. */
export const LARGURA_DE_CELULAR = 480;

const PROPORCAO_NO_CELULAR = 0.84;
const ESPACO_APERTADO = 8;
const ESPACO_FOLGADO = 12;

export interface EncaixeDasColunas {
  /** Piso da coluna, em pixels. Sobrando largura, a coluna cresce a partir dele. */
  coluna: number;
  /** Espaco entre as colunas, em pixels. */
  espaco: number;
  /** Todas as colunas cabem sem rolar. */
  cabe: boolean;
}

export function encaixarColunas(
  disponivel: number,
  colunas: number,
): EncaixeDasColunas {
  const cabeNoMinimo =
    colunas * COLUNA_MINIMA + (colunas - 1) * ESPACO_APERTADO <= disponivel;

  // Antes da primeira medida nao ha largura: nada indica que o quadro vai rolar.
  if (disponivel <= 0 || cabeNoMinimo) {
    const folgado = disponivel / Math.max(colunas, 1) >= COLUNA_CONFORTAVEL;
    return {
      coluna: COLUNA_MINIMA,
      espaco: folgado ? ESPACO_FOLGADO : ESPACO_APERTADO,
      cabe: true,
    };
  }

  return {
    coluna:
      disponivel < LARGURA_DE_CELULAR
        ? Math.round(disponivel * PROPORCAO_NO_CELULAR)
        : COLUNA_CONFORTAVEL,
    espaco: ESPACO_FOLGADO,
    cabe: false,
  };
}
